import AuthForm from "../components/Auth/AuthForm";

const AuthPage = () => {
  return <AuthForm />;
};

export default AuthPage;
